<div class="container-style row mx-0">
  <form novalidate [formGroup]="formPhysicalInventory" errorTailor class="w-100">
    <div class="ps-2 pe-2 mb-2">
      <div class="row">
        <div class="col-lg-6 col-6 d-flex justify-content-start">
          <app-navigation (buttonClick)="getButtonClick($event)" class="d-flex"></app-navigation>
        </div>
        <div class="col-lg-6 col-6 gap-1 d-flex justify-content-end align-items-center">
          <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'danger'"
            (onClick)="deletePhysicalInventory()"></app-custom-button>
        </div>
        <hr class="my-1" />
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <app-custom-audit-info [userNameCreate]="physicalInventoryContract.userNameCreate"
            [createDate]="physicalInventoryContract.createDate"
            [userNameUpdate]="physicalInventoryContract.userNameUpdate"
            [updateDate]="physicalInventoryContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
        </div>
      </div>
      <div class="row px-0 mx-0">
        <div class="row px-0 mx-0">
          <div class="col field-inventory">
            <app-custom-select formControlName="inventoryId" [labelText]="'Inventario'" [list]="listInventories"
              [required]="true" [recovery]="true" (onChangeSelect)="changeInventory()"></app-custom-select>
          </div>
          <div class="col field-branch">
            <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
              [required]="true" [recovery]="true" (onChangeSelect)="changeBranch()"></app-custom-select>
          </div>
          <div class="col field-store">
            <app-custom-select formControlName="storeId" [labelText]="'Bodega'" [list]="listStores" [required]="true"
              [recovery]="true" (onChangeSelect)="createNewRegister()"></app-custom-select>
          </div>
          <div class="col field-consecutive">
            <app-custom-input-number formControlName="consecutive" [labelText]="'Consecutivo'" [required]="true"
              [recovery]="true" (onChangeNumber)="changeConsecutive($event)"></app-custom-input-number>
          </div>
          <div class="col field-date">
            <app-custom-datepicker formControlName="datePhysicalInventory" [labelText]="'Fecha'" [required]="true"
              (onChangeDate)="changeDate()"></app-custom-datepicker>
          </div>
          <div class="col field-date">
            <app-custom-datepicker formControlName="dateAdjustment" [labelText]="'Fecha ajuste'"
              [required]="true"></app-custom-datepicker>
          </div>
          <div class="col field-state">
            <app-custom-tag [label]="'Estado'" [value]="stateLabel()" [severity]="stateSeverity()"></app-custom-tag>
          </div>
          <div class="col field-change-state">
            <app-custom-button [title]="stateButtonLabel()" [icon]="stateButtonIcon()" [severity]="'primary'"
              [disabled]="disabledChangeState" (onClick)="changeState()"></app-custom-button>
          </div>
        </div>
        <div class="row px-0 mx-0 mt-2">
          <div class="col field-observation">
            <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [rows]="1"
              [autoResize]="false" [maxLength]="200"></app-custom-textarea>
          </div>
          <div class="field-save d-flex align-items-end pt-2">
            <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined" [disabled]="disabledSave"
              (onClick)="send()"></app-custom-button>
          </div>
          <div class="field-actions d-flex align-items-end gap-2 col-auto justify-content-end pt-2">
            <app-custom-button [title]="'Ajustar Ent. con Sobrantes'" [label]="'Ajustar Ent. con Sobrantes'"
              [severity]="'success'" width="'8rem'" [disabled]="disabledAdjustExcessBtn"
              (onClick)="openAdjustExcessModal()"></app-custom-button>
            <app-custom-modal #adjustExcessModal [label]="'Seleccionar'" [header]="'Seleccionar Bodega de Ajuste'"
              [children]="componentAdjustExcess" [inputs$]="inputsForAdjustExcessModals$" [width]="'30rem'"
              (params)="adjustExcessResponse($event)" hidden>
            </app-custom-modal>
            <app-custom-button [title]="'Ajustar Sal. con Faltantes'" [label]="'Ajustar Sal. con Faltantes'"
              [severity]="'secondary'" [variant]="'outlined'" width="'8rem'" [disabled]="disabledAdjustMissingBtns"
              (onClick)="adjustMissing()"></app-custom-button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="p-0 mt-2">
  <app-physical-inventory-detail [disabledDetail]="disabledDetail"
    [physicalInventoryModel]="physicalInventoryContract"></app-physical-inventory-detail>
</div>